import React, { useEffect, useState } from 'react';
import { Flex, Box, Text } from '@chakra-ui/react';
import BeatLoader from 'react-spinners/BeatLoader';
import axios from 'axios';

export default function PayRedirect({ match }) {

    const code = match?.params?.code;
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!code) {
            setError('Link di pagamento non valido.');
            return;
        }
        axios.get(process.env.REACT_APP_API + '/pay/' + code)
            .then(response => {
                window.location.href = response.data.url;
            })
            .catch(() => {
                setError('Questo link di pagamento non è valido o è scaduto.');
            });
    }, [code]);

    return (
        <Flex minH="100vh" align="center" justify="center" direction="column" gap={4}>
            {error ? (
                <Box textAlign="center">
                    <Text fontSize="lg" fontWeight="semibold" color="red.500" mb={2}>Link di Pagamento Non Trovato</Text>
                    <Text color="gray.500">{error}</Text>
                </Box>
            ) : (
                <Box textAlign="center">
                    <BeatLoader loading={true} size={15} aria-label="Loading Spinner" color="#422CFA" />
                    <Text mt={4} color="gray.500">Reindirizzamento al pagamento in corso...</Text>
                </Box>
            )}
        </Flex>
    );
}
